import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { bonuses } from "../../data/content";
import { SectionCTA } from "../SectionCTA";
export function Bonuses() {
  return <section className="bg-canvas py-16 md:py-24" data-id="element-129" data-mp="1ckwmoevoutp3">
      <div className="mx-auto max-w-4xl px-4" data-id="element-130" data-mp="1clpiwlx0u0sz">
        <div className="flex justify-center" data-id="element-131" data-mp="18jumnvty6dm2">
          <span className="flex items-center gap-2 rounded-full bg-gold px-4 py-2 text-sm font-extrabold uppercase tracking-wide text-navy" data-id="element-132" data-mp="18l5ohq3u1baj">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="20aqwenkpo254" /> Valued at $197 — Free today
          </span>
        </div>
        <h2 className="mt-5 text-center font-serif text-[30px] font-extrabold leading-tight text-navy md:text-5xl" data-id="element-134" data-mp="1w8nilsakklgo">
          5 exclusive bonuses <em className="italic text-brand" data-id="element-135" data-mp="1r9kdk7ulaf8p">included free</em>
        </h2>
      </div>

      <div className="mx-auto mt-10 max-w-4xl space-y-8 md:px-4" data-id="element-136" data-mp="kuruvv5ln4du">
        {bonuses.map(b => <article key={b.number} className="overflow-hidden bg-white shadow-sm md:rounded-3xl md:border md:border-navy/10" data-id="element-137" data-mp="fu45tf0xkxm9">
            <div className="flex items-center justify-between gap-3 bg-navy px-4 py-3 md:px-8" data-id="element-138" data-mp="1eugcwupylay2">
              <span className="font-serif text-lg font-black uppercase text-gold" data-id="element-139" data-mp="1jryjwfkf1g3f">Bonus #{b.number}</span>
              <span className="text-sm font-semibold text-white/80" data-id="element-140" data-mp="15v2x7kb8rq4w">
                Value: <s className="text-white/60" data-id="element-141" data-mp="1aqi9i7tlpdz7">{b.value}</s> <strong className="ml-1 rounded-md bg-cta px-2 py-0.5 text-white" data-id="element-142" data-mp="w35nyj3sn88t">FREE</strong>
              </span>
            </div>
            <div className="md:grid md:grid-cols-2 md:items-center md:gap-6 md:p-6" data-id="element-143" data-mp="10u5l9pgtrsbu">
              <img src={b.image} alt={`${b.title} mockup`} className="block w-full" data-id="element-144" data-mp="n30p4xco1i69" />
              <div className="px-5 pb-7 pt-2 md:p-0" data-id="element-145" data-mp="r3szjtx9xt44">
                <h3 className="font-serif text-2xl font-extrabold leading-tight text-navy" data-id="element-146" data-mp="r4m1mhlafufx">{b.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-ink-muted" data-id="element-147" data-mp="d531oc2mrpep">{b.text}</p>
                <ul className="mt-4 space-y-2" data-id="element-148" data-mp="i2uwbduntpml">
                  {b.bullets.map(x => <li key={x} className="flex items-center gap-2 text-[15px] font-medium text-ink" data-id="element-149" data-mp="2ju4r4a3yd4hb">
                      <CheckIcon className="h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-150" data-mp="2f0ac3jzaldok" />
                      {x}
                    </li>)}
                </ul>
              </div>
            </div>
          </article>)}
      </div>

      <div className="px-4" data-id="element-151" data-mp="32rxt9a6r5adn">
        <SectionCTA label="Get All 5 Bonuses Free" data-id="element-152" data-mp="32q4o5zbsey7r" />
      </div>
    </section>;
}